import { isElementInViewport, _unsetPanelHeight, _setPanelHeight } from '../utils';
const BREAKPOINT = 1200;


export default class MainNav {
  constructor(el) {
    this.el = typeof el == 'string' ? document.querySelector(el) : el;
    this.state = null;

    this.el.onclick = this.onClick.bind(this);
    window.addEventListener('resize', this.onResize.bind(this));
    this.onResize();
  }

  onResize(e) {
    if (innerWidth < BREAKPOINT && this.state !== 'mobile') {
      this.state = 'mobile';

      // reset sub nav width
      [...this.el.querySelectorAll('.main-nav__list--second .sub-nav')].forEach(el => el.style.width = null);
    }
    else if (innerWidth >= BREAKPOINT && this.state !== 'desktop') {
      this.state = 'desktop';

      // destroy accordion
      const opened = this.el.querySelector('.main-nav__dropdown.opened');
      opened && opened.classList.remove('opened');
      [...this.el.querySelectorAll('.sub-nav[style*=height]')].forEach(el => el.style.height = null);

      // update sub nav panels reverse state and width
      [...this.el.querySelectorAll('.main-nav__list--second .sub-nav')].forEach(el => {
        this.updateSubNavWidth(el);
        this.updateSubNavReverseState(el);
      });
    }
  }

  /**
  * Desktop
  */
  updateSubNavReverseState(el) {
    if (!isElementInViewport(el))
      el.classList.add('reverse');
  }

  // IE 10+ hack
  updateSubNavWidth(el) {
    var width = 0;

    width += el.querySelector('.sub-nav__col--left').offsetWidth;
    width += el.querySelector('.sub-nav__col--right').offsetWidth;
    el.style.width = width + 'px';
  }

  /**
  * Mobile
  */
  onClick(e) {
    if (this.state === 'desktop' || !e.target.closest('.main-nav__link'))
      return;

    const target = e.target.closest('.main-nav__dropdown');
    const prevTarget = this.el.querySelector('.main-nav__dropdown.opened');

    if (target.classList.contains('opened'))
      return this.hideTab(target);

    if (prevTarget)
      this.hideTab(prevTarget);

    this.showTab(target);
  }

  hideTab(el) {
    el.classList.remove('opened');
    _unsetPanelHeight(el.querySelector('.sub-nav'));
  }

  showTab(el) {
    const tabPanel = el.querySelector('.sub-nav');
    if (!tabPanel)
      return;
    el.classList.add('opened');
    _setPanelHeight(tabPanel);
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/js/header/main-nav.js
// module id = 3
// module chunks = 0